__turbopack_context__.v({
  "active": "GroupedProduct-module-scss-module__aIiXJq__active",
  "add-to-cart-button": "GroupedProduct-module-scss-module__aIiXJq__add-to-cart-button",
  "arrows": "GroupedProduct-module-scss-module__aIiXJq__arrows",
  "bulkAddBar": "GroupedProduct-module-scss-module__aIiXJq__bulkAddBar",
  "bulkAddButton": "GroupedProduct-module-scss-module__aIiXJq__bulkAddButton",
  "buttonsContainer": "GroupedProduct-module-scss-module__aIiXJq__buttonsContainer",
  "cart-btn-close": "GroupedProduct-module-scss-module__aIiXJq__cart-btn-close",
  "checkboxRow": "GroupedProduct-module-scss-module__aIiXJq__checkboxRow",
  "groupedDescription": "GroupedProduct-module-scss-module__aIiXJq__groupedDescription",
  "groupedHeaderRow": "GroupedProduct-module-scss-module__aIiXJq__groupedHeaderRow",
  "groupedProductPrice": "GroupedProduct-module-scss-module__aIiXJq__groupedProductPrice",
  "groupedProductWrapper": "GroupedProduct-module-scss-module__aIiXJq__groupedProductWrapper",
  "groupedTotalPrice": "GroupedProduct-module-scss-module__aIiXJq__groupedTotalPrice",
  "groupedWishlist": "GroupedProduct-module-scss-module__aIiXJq__groupedWishlist",
  "infoContainer": "GroupedProduct-module-scss-module__aIiXJq__infoContainer",
  "leftArrowSlickSuggSet": "GroupedProduct-module-scss-module__aIiXJq__leftArrowSlickSuggSet",
  "pdp-qty": "GroupedProduct-module-scss-module__aIiXJq__pdp-qty",
  "pdpPrice": "GroupedProduct-module-scss-module__aIiXJq__pdpPrice",
  "pdpProductPrice": "GroupedProduct-module-scss-module__aIiXJq__pdpProductPrice",
  "pricePerUnitCont": "GroupedProduct-module-scss-module__aIiXJq__pricePerUnitCont",
  "product-name": "GroupedProduct-module-scss-module__aIiXJq__product-name",
  "productButton": "GroupedProduct-module-scss-module__aIiXJq__productButton",
  "productCard": "GroupedProduct-module-scss-module__aIiXJq__productCard",
  "productCardSlider": "GroupedProduct-module-scss-module__aIiXJq__productCardSlider",
  "productDetail": "GroupedProduct-module-scss-module__aIiXJq__productDetail",
  "productDetailWrapper": "GroupedProduct-module-scss-module__aIiXJq__productDetailWrapper",
  "productImage": "GroupedProduct-module-scss-module__aIiXJq__productImage",
  "productList": "GroupedProduct-module-scss-module__aIiXJq__productList",
  "productName": "GroupedProduct-module-scss-module__aIiXJq__productName",
  "productPrice": "GroupedProduct-module-scss-module__aIiXJq__productPrice",
  "productTopInfo": "GroupedProduct-module-scss-module__aIiXJq__productTopInfo",
  "qtySelector": "GroupedProduct-module-scss-module__aIiXJq__qtySelector",
  "qtyTitle": "GroupedProduct-module-scss-module__aIiXJq__qtyTitle",
  "quantity": "GroupedProduct-module-scss-module__aIiXJq__quantity",
  "rightArrowSlickSuggSet": "GroupedProduct-module-scss-module__aIiXJq__rightArrowSlickSuggSet",
  "scrollableContent": "GroupedProduct-module-scss-module__aIiXJq__scrollableContent",
  "select-variant": "GroupedProduct-module-scss-module__aIiXJq__select-variant",
  "separator": "GroupedProduct-module-scss-module__aIiXJq__separator",
  "setContainer": "GroupedProduct-module-scss-module__aIiXJq__setContainer",
  "shortDescription": "GroupedProduct-module-scss-module__aIiXJq__shortDescription",
  "sidebarImageSlider": "GroupedProduct-module-scss-module__aIiXJq__sidebarImageSlider",
  "sidebarPanel": "GroupedProduct-module-scss-module__aIiXJq__sidebarPanel",
  "sku": "GroupedProduct-module-scss-module__aIiXJq__sku",
  "title": "GroupedProduct-module-scss-module__aIiXJq__title",
});
